// Conversions between the "YYYY-MM-DD" strings stored in Firestore and the Date objects used by v-date-picker.
// Both work in local time, so a picked day never shifts by one because of the timezone.

export function isoDateToDate(value) {
  const match = typeof value === "string" ? value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/) : null;
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

export function dateToIsoDate(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    return null;
  }
  const pad = (number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// Unix timestamp in seconds (Stripe, userRole.endDate) to a long French date, e.g. "2 novembre 2027"
export function formatLongDate(seconds) {
  const timestamp = Number(seconds);
  if (!seconds || !Number.isFinite(timestamp)) {
    return "";
  }
  return new Date(timestamp * 1000).toLocaleDateString("fr-CA", { day: "numeric", month: "long", year: "numeric" });
}
